import { Grid } from "@mui/material";
import { OrganizationUserContext } from "contexts/Organization";
import { useContext, useState } from "react";
import { VAStatus } from "schemas/dashboard";

import VAAnnouncement from "./VAAnnouncement";
import VAProgressBar from "./VAProgressBar";
import DiscoverVideo from "./Video";

const DiscoverBanner = () => {
  const { currentOrg } = useContext(OrganizationUserContext);
  const [closeVa, setCloseVa] = useState(false);

  const notQualifiedForVa =
    currentOrg &&
    [VAStatus.disqualified, VAStatus.not_interested].includes(
      currentOrg?.vaStatus,
    );
  const displayVAAnnouncement = !currentOrg?.isVaUser && !notQualifiedForVa;

  return notQualifiedForVa ? (
    <Grid item xs={12}>
      <Grid container justifyContent="center">
        <Grid item xs={12}>
          <DiscoverVideo />
        </Grid>
      </Grid>
    </Grid>
  ) : (
    <Grid item xs={12} sx={{ mb: 2 }}>
      <Grid container justifyContent="center">
        <Grid item xs>
          {currentOrg?.isVaUser && <VAProgressBar />}
          {displayVAAnnouncement && (
            <VAAnnouncement close={closeVa} setClose={setCloseVa} />
          )}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default DiscoverBanner;
